import React, { FC, useState } from "react";
import { Collapse, Switch, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { MoreDetailsInfo } from "../../../interfaces/errorType";
import TechnicalDetails from "./TechnicalDetails";
import KlassyDisclaimer from "../../../../common/klassy/klassyDisclaimer/KlassyDisclaimer";

type Props = {
  moreDetailsInfo: MoreDetailsInfo;
};

const ErrorDetailsSection: FC<Props> = ({ moreDetailsInfo }) => {
  const { t } = useTranslation("annotationSideControls", {
    keyPrefix: "alert.exportFailed.moreDetails",
  });

  const hasUserMessage = !!moreDetailsInfo.userMessage;
  const [showSummary, setShowSummary] = useState(hasUserMessage);

  return (
    <Collapse
      size="small"
      collapsible="header"
      bordered={false}
      defaultActiveKey={["1"]}
      items={[
        {
          key: "1",
          label: t("header"),
          extra: hasUserMessage ? (
            <div
              className="error-ai-toggle"
              onClick={(e) => e.stopPropagation()}
            >
              <Tooltip
                placement="topLeft"
                title={t("aiToggleTooltip")}
                mouseEnterDelay={0.5}
              >
                <i
                  className={`bi bi-stars error-ai-icon ${
                    showSummary ? "active" : ""
                  }`}
                />
              </Tooltip>
              <Switch
                size="small"
                checked={showSummary}
                onChange={setShowSummary}
              />
            </div>
          ) : undefined,
          children:
            showSummary && hasUserMessage ? (
              <div className="error-summary-content">
                <p>{moreDetailsInfo.userMessage}</p>
                <KlassyDisclaimer />
              </div>
            ) : (
              <TechnicalDetails moreDetailsInfo={moreDetailsInfo} />
            ),
        },
      ]}
    />
  );
};

export default ErrorDetailsSection;
